<template>
  <div>
    <template>
      <div class="row pg_sec sec_certifications">
      <div class="col-12 hd ace_sec_hd" aria-label="Experience">
        <h2>Create an Email Campaign</h2>
        <span class="hd_bdr"></span>
      </div>

      <div class="col-12 pg_fld_sec" aria-label="Certifications Chart">
        <div class="row pg_fld_row">

          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
            <div class="row">
              <div class="col-12">
                <div class="fld_label">
                  <label class="label">Name</label> <span class="fld_req">*</span>
                </div>
                <div class="fld_input">
                  <input v-model="emailCampaignObj.name"></input>
                </div>
              </div>
            </div>

            <div class="row mt-2">
              <div class="col-12">
                <div class="fld_label">
                  <label class="label">Description</label>
                </div>
                <div class="fld_input">
                  <textarea v-model="emailCampaignObj.description" class="description"></textarea>
                </div>
              </div>
            </div>

            <div class="row mt-2">
              <div class="col-12 btn_container">
                <b-btn @click="createEmailCampaign">save</b-btn>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    </template>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import BarChart from './BarChart'

export default {
  name: 'emailTemplateCreate',
  props: ['uuid'],
  components: {
    BarChart
  },
  data: () => {
    return {
      emailCampaignObj: {
        name: '',
        description: '',
        institutionId: '',
        campaignId: ''
      }
    }
  },
  mounted () {

  },
  methods: {
    ...mapActions([
      'loadCreateEmailCampaign'
    ]),
    async createEmailCampaign () {
      if (!this.emailCampaignObj.name) {
        this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: 'Name is required.'
        })
        return
      }
      this.emailCampaignObj.institutionId = this.uuid
      this.emailCampaignObj.campaignId = this.makeCampaignId(5)
      await this.loadCreateEmailCampaign(this.emailCampaignObj)
      this.$notify({
        group: 'notify',
        type: 'success',
        title: '',
        text: 'Email Campaign Successfully Created!'
      })
      return this.$router.push({ name: 'emailCampaignList', params: { uuid: this.uuid } })
    },
    makeCampaignId (length) {
      var result = ''
      var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      var charactersLength = characters.length
      for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength))
      }
      return result
    }
  },
  computed: {
    ...mapState({
    })
  }
}
</script>
<style scoped>
.graph-container {
  width: 750px!important;
  max-height: 400px!important;
}
.mt-2 {
  margin-top:20px!important;
}
.tag {
  background: #376573;
    color: #fff;
    border-radius: 0;
    padding: 5px 10px;
    border: none;
}
</style>



// WEBPACK FOOTER //
// src/app/institution/components/EmailCampaignCreate.vue